import {Col, Collapse, Row, Spin, Modal} from "antd";
import {Link} from "react-router-dom";
import {TableWrapper} from "../_defaultComponents/TableWrapper/TableWrapper";
import moment from "moment";
import React, {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import {
    FileSearchOutlined,
    CheckCircleOutlined,
    MinusCircleOutlined,
    TeamOutlined,
    PercentageOutlined
} from "@ant-design/icons";
import {courierTypes} from "../../constants/constants";
import {useFetch} from "../../hooks/useFetch";
import {useStore} from "../../hooks/useStore";
import {CityFilter, SubCompanyWorkTypeFilter} from "../_defaultComponents/FilterComponents";
import DataBox from "./DataBox";
import {OptionsRow, SelectField, Center, DashboardRow, StatCard, SectionCard} from "./styles";

const ShiftCompliance = () => {
    const stores = useStore();

    const {t} = useTranslation(["shiftCompliance"]);
    const allCity = t("filters.all", {ns: "common"});
    const filters = stores.meStore.orderPage?.filters;
    const {Panel} = Collapse;

    const [cities, setCities] = useState();
    const [total, setTotal] = useState();
    const [selectedCity, setSelectedCity] = useState(allCity);
    const [courierType, setCourierType] = useState("all");
    const [workType, setWorkType] = useState("all");
    const [filterCity, setFilterCity] = useState(stores.meStore.map.filters.city);
    const [activeKeys, setActiveKeys] = useState([]);

    const [courierModal, setCourierModal] = useState({
        visible: false,
        loading: false,
        couriers: [],
        title: ""
    });
    const [recall, setRecall] = useState(true);
    const recallRef = useRef(recall);
    recallRef.current = recall;

    const [loading, data, ,] = useFetch({
        defaultDataValue: null,
        initialCall: true,
        fetchFn: stores.shiftStore.getShiftCompliance.bind(null, {
            city: filterCity,
            courierType: courierType,
            workType: workType
        }),
        dependencies: [recall, filterCity, courierType, workType]
    });

    useEffect(() => {
        setTotal(data?.total);
        if (selectedCity === allCity) {
            setCities(data?.result);
            return;
        }
        setCities(data?.result.filter(city => city?.name === selectedCity));
    }, [data]);

    useEffect(() => {
        setTimeout(() => {
            setRecall(!recallRef.current);
        }, 60000);
    }, [recall]);

    const MODAL_TITLES = {
        planned: "Planlanan Vardiyalar",
        realized: "Gerçekleşen Vardiyalar",
        available: "Anlık Müsait Kuryeler",
        notEntered: "Vardiyaya Girmemiş Kuryeler"
    };

    const iconStyle = (color, bg) => ({
        color,
        fontSize: 24,
        backgroundColor: bg,
        padding: 10,
        borderRadius: 10
    });

    const renderDashboard = () => (
        <DashboardRow>
            <StatCard
                color="#0958d9"
                onClick={() => handleCourierBoxClick("planned", total?.subCompanyIds || [])}
            >
                <FileSearchOutlined style={iconStyle("#0958d9", "rgba(9, 88, 217, 0.1)")} />
                <div className="info">
                    <span className="label">Planlanan Vardiya</span>
                    <span className="value">{total?.totalPlannedCourierCount ?? 0}</span>
                </div>
            </StatCard>
            <StatCard
                color="#08979c"
                onClick={() => handleCourierBoxClick("realized", total?.subCompanyIds || [])}
            >
                <CheckCircleOutlined style={iconStyle("#08979c", "rgba(8, 151, 156, 0.1)")} />
                <div className="info">
                    <span className="label">Gerçekleşen Vardiya</span>
                    <span className="value">{total?.totalRealizedShiftCount ?? 0}</span>
                </div>
            </StatCard>
            <StatCard
                color="#cf1322"
                onClick={() => handleCourierBoxClick("notEntered", total?.subCompanyIds || [])}
            >
                <MinusCircleOutlined style={iconStyle("#cf1322", "rgba(207, 19, 34, 0.1)")} />
                <div className="info">
                    <span className="label">Vardiyaya Girmeyenler</span>
                    <span className="value">
                        {(total?.totalPlannedCourierCount ?? 0) -
                            (total?.totalRealizedShiftCount ?? 0)}
                    </span>
                </div>
            </StatCard>
            <StatCard
                color="#389e0d"
                onClick={() => handleCourierBoxClick("available", total?.subCompanyIds || [])}
            >
                <TeamOutlined style={iconStyle("#389e0d", "rgba(56, 158, 13, 0.1)")} />
                <div className="info">
                    <span className="label">Anlık Müsait Kuryeler</span>
                    <span className="value">{total?.totalCurrentlyAvailableCourierCount ?? 0}</span>
                </div>
            </StatCard>
            <StatCard color="#389e0d">
                <PercentageOutlined style={iconStyle("#389e0d", "rgba(56, 158, 13, 0.1)")} />
                <div className="info">
                    <span className="label">Uyum Oranı</span>
                    <span className="value">{total?.complianceRate ?? 0}%</span>
                </div>
            </StatCard>
        </DashboardRow>
    );

    const handleCourierBoxClick = async (type, subCompanyIds) => {
        setCourierModal({
            visible: true,
            loading: true,
            couriers: [],
            title: MODAL_TITLES[type] || ""
        });
        const res = await stores.shiftStore.getComplianceCouriers({
            subCompanyIds,
            courierType,
            type,
            datetime: new Date()
        });
        setCourierModal(prev => ({...prev, loading: false, couriers: res?.result || []}));
    };

    const renderData = (branchData, isFirst = false) => {
        return (
            branchData &&
            branchData.map((branch, i) => {
                const panel = (
                    <Panel
                        header={
                            <DataBox
                                data={branch}
                                onClick={e => {
                                    !branch?.items && e.stopPropagation();
                                }}
                                onCourierBoxClick={type =>
                                    handleCourierBoxClick(type, branch.subCompanyIds || [])
                                }
                            />
                        }
                        className={isFirst ? "custom" : ""}
                        key={`${branch.name}-${i}`}
                        showArrow={!!branch?.items}
                    >
                        {branch?.items?.length > 0 && (
                            <Collapse destroyInactivePanel>{renderData(branch.items)}</Collapse>
                        )}
                        {!branch?.items && <></>}
                    </Panel>
                );

                if (isFirst) {
                    return (
                        <SectionCard key={`sc-${branch.name}-${i}`}>
                            <Collapse defaultActiveKey={activeKeys} destroyInactivePanel>
                                {panel}
                            </Collapse>
                        </SectionCard>
                    );
                }
                return panel;
            })
        );
    };
    return (
        <div>
            <OptionsRow type="flex" justify="space-between" data-testid="ShiftCompliance">
                <Col lg={24} xl={18} xxl={20}>
                    <Row type="flex" gutter={[20, 20]}>
                        {
                            <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                                <CityFilter
                                    value={filterCity}
                                    onChange={value => {
                                        setFilterCity(value);
                                        setActiveKeys([]);
                                        stores.meStore.map.filters.city = value;
                                    }}
                                />
                            </Col>
                        }
                        {
                            <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                                <h5>{t("fields.courierType", {ns: "common"})}</h5>
                                <SelectField
                                    data-testid="courierTypeSelect"
                                    value={courierType}
                                    placeholder={t("filters.addFilter", {ns: "common"})}
                                    onChange={value => setCourierType(value)}
                                >
                                    <SelectField.Option
                                        data-testid="courierTypeSelect_option"
                                        key={"courierType-all"}
                                        value={"all"}
                                    >
                                        {t("filters.all", {ns: "common"})}
                                    </SelectField.Option>
                                    {courierTypes.map(type => (
                                        <SelectField.Option
                                            key={type.value}
                                            value={type.value}
                                            data-testid="courierTypeSelect_option"
                                        >
                                            <span>
                                                {t(type.translation_key, {ns: "courierTypes"})}
                                            </span>
                                        </SelectField.Option>
                                    ))}
                                </SelectField>
                            </Col>
                        }
                        {
                            <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                                <SubCompanyWorkTypeFilter
                                    showAllOption
                                    syncWithStore={false}
                                    dedicatedLabel="Dedike"
                                    value={workType}
                                    onChange={value => {
                                        setWorkType(value);
                                        setActiveKeys([]);
                                    }}
                                />
                            </Col>
                        }
                    </Row>
                </Col>
            </OptionsRow>
            <Col span={24}>
                {renderDashboard()}
                {activeKeys.length === 0 && loading ? (
                    <Center>
                        <Spin size="large" spinning={loading}></Spin>
                    </Center>
                ) : (
                    <>{renderData(cities, true)}</>
                )}
            </Col>
            <Modal
                title={courierModal.title}
                visible={courierModal.visible}
                onCancel={() =>
                    setCourierModal({visible: false, loading: false, couriers: [], title: ""})
                }
                footer={null}
                width={900}
                style={{maxWidth: "95vw"}}
                destroyOnClose
            >
                <TableWrapper
                    style={{boxShadow: "none", padding: 0, borderRadius: 0}}
                    loading={courierModal.loading}
                    dataSource={courierModal.couriers}
                    rowKey={r => `${r.firmName}-${r.subCompanyName}-${r.shiftDate}`}
                    pagination={{pageSize: 10, hideOnSinglePage: true}}
                    columns={[
                        {
                            title: "Kurye Adı",
                            dataIndex: "courierName",
                            render: (v, r) =>
                                r.courierId ? <Link to={`/couriers/${r.courierId}`}>{v}</Link> : v
                        },
                        {
                            title: "Tarih",
                            dataIndex: "shiftDate",
                            render: v => moment(v).format("DD.MM.YYYY")
                        },
                        {
                            title: "Çalışma Tipi",
                            dataIndex: "workType",
                            render: v => (v === "pool" ? "Havuz" : "Dedike")
                        },
                        {title: "Şehir", dataIndex: "city"},
                        {title: "Havuz/Firma", dataIndex: "firmName"},
                        {
                            title: "Alt Firma",
                            dataIndex: "subCompanyName",
                            render: (v, r) =>
                                r.subCompanyId ? (
                                    <Link to={`/companies/sub-company/${r.subCompanyId}`}>{v}</Link>
                                ) : (
                                    v
                                )
                        },
                        {title: "Planlanan Vardiya", dataIndex: "plannedShift"}
                    ]}
                />
            </Modal>
        </div>
    );
};

export default ShiftCompliance;
